import * as Yup from 'yup'
import { formHelper } from '@/features/profile/helpers'
import { ValidationsUtils } from '@/utils'

export const validationSchema = Yup.object().shape({
  invoice_number: Yup.string().nullable().required('field.error.required'),
  amount: Yup.string().nullable().required('field.error.required'),
  file: Yup.string().nullable().required('field.error.required'),
})
